/* eslint-disable max-lines */
import complaintsApi from '../../api/complaints-api';
import { ROUTE_NAMES } from './constants/complaint-constants';
const COMPLAINTS_SET_INIT_DATA = 'COMPLAINTS_SET_INIT_DATA';
const COMPLAINTS_ADD_VISITED_PAGE = 'COMPLAINTS_ADD_VISITED_PAGE';
const COMPLAINTS_SET_CURRENT_PAGE = 'COMPLAINTS_SET_CURRENT_PAGE';
const COMPLAINTS_ADD_VALID_PAGE = 'COMPLAINTS_ADD_VALID_PAGE';
const COMPLAINTS_SET_TECHNICAL_ERROR = 'COMPLAINTS_SET_TECHNICAL_ERROR';
const COMPLAINTS_SET_SESSION_ID = 'COMPLAINTS_SET_SESSION_ID';
const COMPLAINTS_SET_CAPTCHA = 'COMPLAINTS_SET_CAPTCHA';
const COMPLAINTS_SET_LOADING = 'COMPLAINTS_SET_LOADING';
const COMPLAINTS_SET_CAPTCHA_BACKEND_ERROR = 'COMPLAINTS_SET_CAPTCHA_BACKEND_ERROR';
const COMPLAINTS_SET_PROBLEM_DATA = 'COMPLAINTS_SET_PROBLEM_DATA';
const COMPLAINTS_SET_CAPTCHA_VALIDATED = 'COMPLAINTS_SET_CAPTCHA_VALIDATED';
const COMPLAINTS_SET_COMPLETED = 'COMPLAINTS_SET_COMPLETED';
const COMPLAINTS_GET_SETTLEMENTS = 'COMPLAINTS_GET_SETTLEMENTS';
const COMPLAINTS_SET_PERSONAL_MODEL = 'COMPLAINTS_SET_PERSONAL_MODEL';
const COMPLAINTS_REMOVE_VALID_PAGE = 'COMPLAINTS_REMOVE_VALID_PAGE';
const COMPLAINTS_REMOVE_VISITED_PAGE = 'COMPLAINTS_REMOVE_VISITED_PAGE';
const COMPLAINTS_SET_BANK_ACCOUNT_NUMBER_VALIDATIOS = 'COMPLAINTS_SET_BANK_ACCOUNT_NUMBER_VALIDATIOS';
const COMPLAINTS_SET_FILES_UPLOADED = 'COMPLAINTS_SET_FILES_UPLOADED';
const COMPLAINTS_SET_UPLOAD_ERROR_CODE = 'COMPLAINTS_SET_UPLOAD_ERROR_CODE';

const complaintsState = {
	initData: {},
	loading: false,
	visitedPages: [],
	validPages: [],
	currentPage: null,
	technicalError: false,
	completed: false,
	captcha: {},
	sessionId: '',
	captchaBackendError: false,
	problemData: null,
	captchaValidated: false,
	settlements: [],
	personalModel: null,
	filesUploaded: [],
	uploadErrorCode: null,
	bankAccountNumberValidations: {
		accountMandatory: null,
		cardNumberAppears: null,
		cardNumberMandatory: null
	}
};

const complaintsGetters = {
	isOnFirstPage: (state) => {
		return state.currentPage == ROUTE_NAMES.PROBLEM;
	},
	lastVisitedPage: (state) => {
		if (state.visitedPages.length) {
			return state.visitedPages[state.visitedPages.length - 1];
		} else {
			return null;
		}
	},
	settlementList: (state) => {
		return state.settlements && state.settlements.map((settlement) => settlement.name);
	}
};

const complaintsActions = {
	getInitData({ commit, state }, lang) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			complaintsApi
				.getInitData(lang)
				.then(
					(response) => {
						commit(COMPLAINTS_SET_INIT_DATA, response.data);
						commit(COMPLAINTS_SET_SESSION_ID, response.data.sessionId);
						commit(COMPLAINTS_SET_CAPTCHA, response.data.captcha);
					},
					() => {
						commit(COMPLAINTS_SET_TECHNICAL_ERROR, true);
					}
				)
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		}
	},
	initFirstStep({ commit }, page) {
		commit(COMPLAINTS_ADD_VISITED_PAGE, page);
		commit(COMPLAINTS_SET_CURRENT_PAGE, page);
	},
	goToNextStep({ commit, state }, pages) {
		commit(COMPLAINTS_ADD_VALID_PAGE, pages.current);
		commit(COMPLAINTS_SET_CURRENT_PAGE, pages.next);
		if (state.visitedPages.indexOf(pages.next) == -1) {
			commit(COMPLAINTS_ADD_VISITED_PAGE, pages.next);
		}
	},
	uploadFile({ commit, state }, file) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			commit(COMPLAINTS_SET_UPLOAD_ERROR_CODE, null);
			complaintsApi
				.uploadFile(file.raw, state.sessionId)
				.then((response) => {
					commit(COMPLAINTS_SET_FILES_UPLOADED, response.data.files);
					for (let fileItem of response.data.files) {
						if (fileItem.errorCode) {
							commit(COMPLAINTS_SET_UPLOAD_ERROR_CODE, fileItem.errorCode);
						}
					}
				})
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		}
	},
	deleteFile({ commit, state }, fileId) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			let dataToSend = {
				fileId,
				sessionId: state.sessionId
			};
			complaintsApi
				.deleteFile(dataToSend)
				.then((response) => {
					commit(COMPLAINTS_SET_FILES_UPLOADED, response.data.files);
				})
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		}
	},
	getSettlements({ commit, state }, zipCode) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			complaintsApi
				.getSettlements(zipCode)
				.then((response) => {
					const settlements = response.data;
					commit(COMPLAINTS_GET_SETTLEMENTS, settlements);
				})
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		}
	},
	submitProblemForm({ commit, state }, { model, currentSubTopic, lang }) {
		if (!state.loading) {
			let redirectToSecondPage;
			commit(COMPLAINTS_SET_LOADING, true);
			commit(COMPLAINTS_SET_CAPTCHA_BACKEND_ERROR, false);
			commit(COMPLAINTS_SET_PROBLEM_DATA, model);
			let bankAccountNumberValidations = {
				accountMandatory: currentSubTopic ? currentSubTopic.accountMandatory : null,
				cardNumberAppears: currentSubTopic ? currentSubTopic.cardNumberAppears : null,
				cardNumberMandatory: currentSubTopic ? currentSubTopic.cardNumberMandatory : null
			};
			redirectToSecondPage = false;
			if (
				state.bankAccountNumberValidations.accountMandatory !== bankAccountNumberValidations.accountMandatory ||
				state.bankAccountNumberValidations.cardNumberAppears !== bankAccountNumberValidations.cardNumberAppears ||
				state.bankAccountNumberValidations.cardNumberMandatory !== bankAccountNumberValidations.cardNumberMandatory
			) {
				if (state.visitedPages.includes(ROUTE_NAMES.PERSONAL)) {
					redirectToSecondPage = true;
				}
				commit(COMPLAINTS_SET_BANK_ACCOUNT_NUMBER_VALIDATIOS, bankAccountNumberValidations);
				commit(COMPLAINTS_REMOVE_VALID_PAGE, ROUTE_NAMES.SUMMARY);
				commit(COMPLAINTS_REMOVE_VALID_PAGE, ROUTE_NAMES.PERSONAL);
				commit(COMPLAINTS_REMOVE_VISITED_PAGE, ROUTE_NAMES.SUMMARY);
				commit(COMPLAINTS_REMOVE_VISITED_PAGE, ROUTE_NAMES.PERSONAL);
			}
			let dataToSend = {
				...model,
				sessionId: state.sessionId
			};
			dataToSend.captcha.captchaId = state.initData.captcha.captchaId;
			return complaintsApi
				.postProblemForm(dataToSend, lang)
				.then(
					() => {
						commit(COMPLAINTS_SET_CAPTCHA_VALIDATED, true);
						return Promise.resolve(redirectToSecondPage);
					},
					(error) => {
						if (error && error.response && error.response.data && error.response.data.captcha && error.response.data.captcha.valid === false) {
							commit(COMPLAINTS_SET_CAPTCHA_BACKEND_ERROR, true);
							commit(COMPLAINTS_SET_CAPTCHA, error.response.data.captcha.captcha);
						} else {
							commit(COMPLAINTS_SET_TECHNICAL_ERROR, true);
						}
						return Promise.reject();
					}
				)
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		} else {
			return Promise.reject();
		}
	},
	storePersonalModel({ commit, state }, { model, lang }) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			commit(COMPLAINTS_SET_PERSONAL_MODEL, model);
			const modelToSend = Object.assign({}, model);
			modelToSend.sessionId = state.sessionId;
			modelToSend.accountNumber = modelToSend.accountNumber ? modelToSend.accountNumber.replace(/-/g, ' ') : null;
			if (modelToSend.isForeigner) {
				modelToSend.phoneNumber = modelToSend.phoneNumber.replace(/-/g, ' ');
			}
			return complaintsApi
				.postPersonalForm(modelToSend, lang)
				.then(
					() => {
						Promise.resolve();
					},
					() => {
						commit(COMPLAINTS_SET_TECHNICAL_ERROR, true);
						Promise.reject();
					}
				)
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		} else {
			return Promise.reject();
		}
	},
	addValidPages({ commit }, page) {
		commit(COMPLAINTS_ADD_VALID_PAGE, page);
	},
	removeValidPages({ commit }, page) {
		commit(COMPLAINTS_REMOVE_VALID_PAGE, page);
	},
	addVisitedPage({ commit }, page) {
		commit(COMPLAINTS_ADD_VISITED_PAGE, page);
	},
	setCurrentPage({ commit }, page) {
		commit(COMPLAINTS_SET_CURRENT_PAGE, page);
	},
	finalize({ state, commit }, lang) {
		if (!state.loading) {
			commit(COMPLAINTS_SET_LOADING, true);
			complaintsApi
				.finalize(state.sessionId, lang)
				.then(
					() => {
						commit(COMPLAINTS_SET_COMPLETED, true);
					},
					() => {
						commit(COMPLAINTS_SET_TECHNICAL_ERROR, true);
					}
				)
				.finally(() => {
					commit(COMPLAINTS_SET_LOADING, false);
				});
		}
	},
	setTechnicalError({ commit }, technicalError) {
		commit(COMPLAINTS_SET_TECHNICAL_ERROR, technicalError);
	}
};
const complaintsMutations = {
	[COMPLAINTS_SET_INIT_DATA](state, initData) {
		state.initData = initData;
	},
	[COMPLAINTS_ADD_VISITED_PAGE](state, page) {
		if (state.visitedPages.indexOf(page) == -1) {
			state.visitedPages.push(page);
		}
	},
	[COMPLAINTS_SET_CURRENT_PAGE](state, page) {
		state.currentPage = page;
	},
	[COMPLAINTS_ADD_VALID_PAGE](state, page) {
		if (state.validPages.indexOf(page) == -1) {
			state.validPages.push(page);
		}
	},
	[COMPLAINTS_SET_TECHNICAL_ERROR](state, technicalError) {
		state.technicalError = technicalError;
	},
	[COMPLAINTS_SET_SESSION_ID](state, sessionId) {
		state.sessionId = sessionId;
	},
	[COMPLAINTS_SET_CAPTCHA](state, captcha) {
		state.captcha = captcha;
	},
	[COMPLAINTS_SET_LOADING](state, loading) {
		state.loading = loading;
	},
	[COMPLAINTS_SET_CAPTCHA_BACKEND_ERROR](state, captchaBackendError) {
		state.captchaBackendError = captchaBackendError;
	},
	[COMPLAINTS_SET_PROBLEM_DATA](state, problemData) {
		state.problemData = problemData;
	},
	[COMPLAINTS_SET_CAPTCHA_VALIDATED](state, captchaValidated) {
		state.captchaValidated = captchaValidated;
	},
	[COMPLAINTS_GET_SETTLEMENTS](state, settlements) {
		state.settlements = settlements;
	},
	[COMPLAINTS_SET_PERSONAL_MODEL](state, model) {
		state.personalModel = model;
	},
	[COMPLAINTS_REMOVE_VALID_PAGE](state, page) {
		let index = state.validPages.indexOf(page);
		if (index > -1) {
			state.validPages.splice(index, 1);
		}
	},
	[COMPLAINTS_REMOVE_VISITED_PAGE](state, page) {
		let index = state.visitedPages.indexOf(page);
		if (index > -1) {
			state.visitedPages.splice(index, 1);
		}
	},
	[COMPLAINTS_SET_COMPLETED](state, completed) {
		state.completed = completed;
	},
	[COMPLAINTS_SET_BANK_ACCOUNT_NUMBER_VALIDATIOS](state, bankAccountNumberValidations) {
		state.bankAccountNumberValidations = bankAccountNumberValidations;
	},
	[COMPLAINTS_SET_FILES_UPLOADED](state, files) {
		state.filesUploaded = files;
	},
	[COMPLAINTS_SET_UPLOAD_ERROR_CODE](state, errorCode) {
		state.uploadErrorCode = errorCode;
	}
};
export default {
	namespaced: true,
	state: complaintsState,
	getters: complaintsGetters,
	mutations: complaintsMutations,
	actions: complaintsActions
};
